export default __webpack_public_path__ + "static/training-7ed09ca84e1550350d95b6842990f74d.png";